<script lang="ts" setup>
import { usePage } from '@inertiajs/vue3';
import { SelectField } from '@vue-interface/select-field';
import type { MgDataVariable } from 'types';
import { computed, watchEffect } from 'vue';

const page = usePage<{
    states: Record<string,string>
}>();

const props = defineProps<{
    id: string,
    name: string,
    item: MgDataVariable,
    index: number,
    errors: Record<string, string>,
    modelValue?: string|string[]
}>();

const emit = defineEmits<{
    'update:modelValue': [value: string[]],
    'update:formattedValue': [value: string],
    'update:readableValue': [value: string[]]
}>();

const model = computed({
    get() {
        if(!props.modelValue) {
            return [];
        }

        if(Array.isArray(props.modelValue)) {
            return props.modelValue;
        }

        return [props.modelValue];
    },
    set(value) {
        emit('update:modelValue', value);
    }
});

const isDefault = computed(() => {
    return JSON.stringify(model.value) === JSON.stringify([props.item.defaultValue]);
});

watchEffect(() => {
    if(isDefault.value && props.item.defaultValue) {
        return emit('update:formattedValue', props.item.defaultValue);
    }
    emit('update:formattedValue', model.value.map(value => `'${value}'`).join(', '));

    emit('update:readableValue', model.value.map(i => {
        return page.props.states[i];
    }));
});
</script>

<template>
    <div class="flex items-center gap-2">
        <SelectField
            :id="id"
            v-model="model"
            multiple
            :name="name"
            class="w-full"
            :error="errors[name]">
            <option
                v-for="state in Object.keys(page.props.states)"
                :key="state"
                :value="state">
                {{ page.props.states[state] }}
            </option>
        </SelectField>
        <slot
            v-if="!isDefault"
            name="reset" />
    </div>
</template>